module.exports = __webpack_public_path__ + "static/media/perler-coasters.eba45b00.jpg";